import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AnalyticsCore from './AnalyticsCore';
import { AppSelectors } from '../../Redux/modules/app/selectors';

/**
 * @augments {Component<{  eventCategory:string,  eventName:string,  eventLabel:string,  eventValue:string.number ,>}
 */
class AnalyticsHandler extends Component {
  originalClick = null;

  renderElement = null;

  onClickHandler = (e) => {
    const { user, tracking, eventName, eventCategory, eventLabel, eventValue, eventData } = this.props;
    if (this.props.tracking.isEnabled) {
      const trackingData = AnalyticsCore.buildEvent({
        user,
        tracking,
        eventName,
        eventCategory,
        eventLabel,
        eventValue,
        eventData,
      });

      AnalyticsCore.sendEvent(trackingData);
    }

    if (this.originalClick != null) {
      this.originalClick(e);
    }
  };

  onMiddleClickHandler = (e) => {
    if (e.button === 1) {
      this.onClickHandler(e);
    }
  };

  render() {
    if (this.props.children.length > 1) {
      throw Error('AnalyticsHandler can handle only one children element');
    }
    React.Children.forEach(this.props.children, (element) => {
      if (!React.isValidElement(element)) return;

      if (this.props.callbackAction && element.props[this.props.callbackAction]) {
        this.originalClick = element.props[this.props.callbackAction];
      } else if (element.props.onClick) {
        this.originalClick = element.props.onClick;
      }

      this.renderElement = React.cloneElement(element, {
        [this.props.callbackAction]: this.onClickHandler,
        onMouseUp: this.onMiddleClickHandler,
      });

      // do something with source..
    });
    return this.renderElement;
  }
}

AnalyticsHandler.propTypes = {
  children: PropTypes.node.isRequired,
  eventName: PropTypes.string.isRequired,

  user: PropTypes.object,
  tracking: PropTypes.object.isRequired,
  eventCategory: PropTypes.string,
  eventLabel: PropTypes.string,
  eventValue: PropTypes.number,
  eventData: PropTypes.object,
  /* Catch callback action which is not onClick */
  callbackAction: PropTypes.string,
};

AnalyticsHandler.defaultProps = {
  eventCategory: 'ACCOUNTS_BI_EVENTS',
  callbackAction: 'onClick',
};

const mapAction = {};

const mapStateToProps = (state) => {
  return {
    user: AppSelectors.userSelector(state),
    tracking: AppSelectors.trackingSelector(state),
  };
};

const withConnect = connect(mapStateToProps, mapAction);

export default withConnect(AnalyticsHandler);
